import { TApplicationState } from '../../types/redux';
import { getUrlPath } from '../path';

export const genplanSeoPageUrlSelector = (state: TApplicationState): string => {
  const fullPath = getUrlPath(state);

  return `${fullPath}genplan/`;
};
